module.exports = __webpack_public_path__ + "img/westobyc.1ad0b333.jpg";